export default {
	horizontal: [''],
	vertical: ['divider--vertical']
};
